import { VideoSection } from "@domain/lms/article/article";
import { SectionController } from "@ui/pages/lms/article/articleEditorPage/sectionEditor/sectionController";
export class VideoSectionController extends SectionController<VideoSection> {
	setUrl(url: string): void {
		this.sectionUpdater((section) => ({ ...section, url }));
	}
}
